export interface Bq10MiscellaneousM {
  constantExcludingFreshWater: string;
  constantExcludingFreshWaterComments: string;
  domesticFreshWaterConsumption: string;
  storageCapacityFreshWater: string;
  fwEvaporatorDailyProduction: string;
  fwEvaporatorCapacity: string;
  normalFreshWaterReserve: string;

  // Insurance (P&I)
  pAndIClubName: string;
  pAndIClubAddress: string;
  pAndIClubTelephone: string;
  pAndIClubFax: string;
  pAndIClubTelex: string;
  pAndIClubEmail: string;
  pAndIClubWebsite: string;
  pAndIPollutionLiabilityCoverage: string;
  pAndIPollutionLiabilityCoverageComments: string;
  handmInsurer: string;
  handmInsuredValue: string;
  isRightShipApproved: string;
  isRightShipApprovedComments: string;
  lastRightShipInspectionDate: string;
  lastRightShipInspectionPlace: string;
  lastIDWALInspectionDate: string;
  lastIDWALInspectionPlace: string;

  // Port State Control
  lastPSCDate: string;
  lastPSCDateComments: string;
  lastPSCPort: string;
  lastPSCPortComments: string;
  outstandingDeficienciesPSC: string;
  outstandingDeficienciesPSCComments: string;
  deficienciesPSCDetails: string;
  vesselGHGRightShip: string;
  anySanctions: string;
  anySanctionsDetails: string;
  amsaDetentions: string;
  supplementaryCommoditiesInfo: string;

  // Email copy
  sendByReturnEmail: boolean;
}

export const initlaBq10Miscellaneous: Bq10MiscellaneousM = {
  constantExcludingFreshWater: "",
  constantExcludingFreshWaterComments: "",
  domesticFreshWaterConsumption: "",
  storageCapacityFreshWater: "",
  fwEvaporatorDailyProduction: "",
  fwEvaporatorCapacity: "",
  normalFreshWaterReserve: "",
  pAndIClubName: "",
  pAndIClubAddress: "",
  pAndIClubTelephone: "",
  pAndIClubFax: "",
  pAndIClubTelex: "",
  pAndIClubEmail: "",
  pAndIClubWebsite: "",
  pAndIPollutionLiabilityCoverage: "",
  pAndIPollutionLiabilityCoverageComments: "",
  handmInsurer: "",
  handmInsuredValue: "",
  isRightShipApproved: "",
  isRightShipApprovedComments: "",
  lastRightShipInspectionDate: "",
  lastRightShipInspectionPlace: "",
  lastIDWALInspectionDate: "",
  lastIDWALInspectionPlace: "",
  lastPSCDate: "",
  lastPSCDateComments: "",
  lastPSCPort: "",
  lastPSCPortComments: "",
  outstandingDeficienciesPSC: "",
  outstandingDeficienciesPSCComments: "",
  deficienciesPSCDetails: "",
  vesselGHGRightShip: "",
  anySanctions: "",
  anySanctionsDetails: "",
  amsaDetentions: "",
  supplementaryCommoditiesInfo: "",
  sendByReturnEmail: false,
};

export function mapSqlToBq10MiscellaneousForm(genInfo: any): Bq10MiscellaneousM {
  return {
    constantExcludingFreshWater: genInfo?.CONSTANT_EXCLUDING_FRESH_WATER || "",
    constantExcludingFreshWaterComments: genInfo?.CONSTANT_EXCLUDING_FRESH_WATER_COMMENTS || "",
    domesticFreshWaterConsumption: genInfo?.DOMESTIC_FRESH_WATER_CONSUMPTION || "",
    storageCapacityFreshWater: genInfo?.STORAGE_CAPACITY_FRESH_WATER || "",
    fwEvaporatorDailyProduction: genInfo?.FW_EVAPORATOR_DAILY_PRODUCTION || "",
    fwEvaporatorCapacity: genInfo?.FW_EVAPORATOR_CAPACITY || "",
    normalFreshWaterReserve: genInfo?.NORMAL_FRESH_WATER_RESERVE || "",
    pAndIClubName: genInfo?.P_AND_I_CLUB_NAME || "",
    pAndIClubAddress: genInfo?.P_AND_I_CLUB_ADDRESS || "",
    pAndIClubTelephone: genInfo?.P_AND_I_CLUB_TELEPHONE || "",
    pAndIClubFax: genInfo?.P_AND_I_CLUB_FAX || "",
    pAndIClubTelex: genInfo?.P_AND_I_CLUB_TELEX || "",
    pAndIClubEmail: genInfo?.P_AND_I_CLUB_EMAIL || "",
    pAndIClubWebsite: genInfo?.P_AND_I_CLUB_WEBSITE || "",
    pAndIPollutionLiabilityCoverage: genInfo?.P_AND_I_POLLUTION_LIABILITY_COVERAGE || "",
    pAndIPollutionLiabilityCoverageComments: genInfo?.P_AND_I_POLLUTION_LIABILITY_COVERAGE_COMMENTS || "",
    handmInsurer: genInfo?.HANDM_INSURER || "",
    handmInsuredValue: genInfo?.HANDM_INSURED_VALUE || "",
    isRightShipApproved: genInfo?.IS_RIGHT_SHIP_APPROVED || "",
    isRightShipApprovedComments: genInfo?.IS_RIGHT_SHIP_APPROVED_COMMENTS || "",
    lastRightShipInspectionDate: genInfo?.LAST_RIGHT_SHIP_INSPECTION_DATE || "",
    lastRightShipInspectionPlace: genInfo?.LAST_RIGHT_SHIP_INSPECTION_PLACE || "",
    lastIDWALInspectionDate: genInfo?.LAST_IDWAL_INSPECTION_DATE || "",
    lastIDWALInspectionPlace: genInfo?.LAST_IDWAL_INSPECTION_PLACE || "",
    lastPSCDate: genInfo?.LAST_PSC_DATE || "",
    lastPSCDateComments: genInfo?.LAST_PSC_DATE_COMMENTS || "",
    lastPSCPort: genInfo?.LAST_PSC_PORT || "",
    lastPSCPortComments: genInfo?.LAST_PSC_PORT_COMMENTS || "",
    outstandingDeficienciesPSC: genInfo?.OUTSTANDING_DEFICIENCIES_PSC || "",
    outstandingDeficienciesPSCComments: genInfo?.OUTSTANDING_DEFICIENCIES_PSC_COMMENTS || "",
    deficienciesPSCDetails: genInfo?.DEFICIENCIES_PSC_DETAILS || "",
    vesselGHGRightShip: genInfo?.VESSEL_GHG_RIGHT_SHIP || "",
    anySanctions: genInfo?.ANY_SANCTIONS || "",
    anySanctionsDetails: genInfo?.ANY_SANCTIONS_DETAILS || "",
    amsaDetentions: genInfo?.AMSA_DETENTIONS || "",
    supplementaryCommoditiesInfo: genInfo?.SUPPLEMENTARY_COMMODITIES_INFO || "",
    sendByReturnEmail: genInfo?.SEND_BY_RETURN_EMAIL || false,
  };
}
